import { reviews } from '@/mocks/home';

export default function HotReviews() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 mb-3">
            <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
              <i className="ri-chat-quote-line text-primary-600 text-sm w-4 h-4 flex items-center justify-center"></i>
            </div>
            <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider">网友热评</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
            吃瓜群众<span className="italic text-primary-600">热议</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {reviews.slice(0, 2).map((review) => (
              <div
                key={review.id}
                className="bg-background-50 rounded-xl p-5 flex flex-col"
              >
                <div className="flex items-center gap-3 mb-3">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
                    <p className="text-xs text-foreground-400">{review.role}</p>
                  </div>
                </div>
                <div className="mb-2">
                  <i className="ri-double-quotes-l text-2xl text-accent-300 w-5 h-5 flex items-center justify-center"></i>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed flex-1">{review.content}</p>
              </div>
            ))}
          </div>

          <div className="relative rounded-xl overflow-hidden h-72 md:h-auto">
            <img
              src={reviews[2].avatar}
              alt={reviews[2].name}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <p className="text-white font-semibold text-sm">{reviews[2].name}</p>
              <p className="text-white/60 text-xs">{reviews[2].role}</p>
            </div>
          </div>

          <div className="md:col-span-2 relative rounded-xl overflow-hidden h-56">
            <img
              src={reviews[3].avatar}
              alt={reviews[3].name}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 max-w-lg">
              <p className="text-white font-semibold text-sm mb-1">{reviews[3].name} · {reviews[3].role}</p>
              <p className="text-white/80 text-sm leading-relaxed line-clamp-2">{reviews[3].content}</p>
            </div>
          </div>

          <div className="grid grid-rows-2 gap-4">
            <div className="bg-background-50 rounded-xl p-4 flex flex-col">
              <div className="mb-2">
                <i className="ri-double-quotes-l text-2xl text-accent-300 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed flex-1 line-clamp-3">{reviews[4].content}</p>
              <div className="flex items-center gap-3 mt-3">
                <img
                  src={reviews[4].avatar}
                  alt={reviews[4].name}
                  className="w-8 h-8 rounded-full object-cover"
                />
                <div>
                  <p className="text-xs font-semibold text-foreground-900">{reviews[4].name}</p>
                  <p className="text-xs text-foreground-400">{reviews[4].role}</p>
                </div>
              </div>
            </div>
            <div className="bg-background-50 rounded-xl p-4 flex flex-col">
              <div className="flex items-center gap-3 mb-2">
                <img
                  src={reviews[0].avatar}
                  alt={reviews[0].name}
                  className="w-8 h-8 rounded-full object-cover"
                />
                <div>
                  <p className="text-xs font-semibold text-foreground-900">匿名网友</p>
                  <p className="text-xs text-foreground-400">持续关注</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed line-clamp-2">
                这个瓜真的越来越大，每天都有新进展，我已经把黑料在线设为浏览器首页了！
              </p>
              <div className="mt-auto pt-2">
                <i className="ri-double-quotes-l text-2xl text-accent-300 w-5 h-5 flex items-center justify-center"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}